
import { codiciAttributo } from '../../../constants/CodiciAttributo';

export const codiciAttributoAnagrafica = [
  codiciAttributo.TX_NOME_UTENTE,
  codiciAttributo.TX_COGNOME_UTENTE,
  codiciAttributo.CD_SESSO_UTENTE,
  codiciAttributo.TX_LUOGO_DI_NASCITA_UTENTE,
  codiciAttributo.CD_STATO_DI_NASCITA_UTENTE,
  codiciAttributo.DT_NASCITA_UTENTE,
  codiciAttributo.TX_CODICE_FISCALE,
  codiciAttributo.CD_CITTADINANZA_UTENTE,
  codiciAttributo.TX_NR_CARTA_DI_IDENTITA,
  codiciAttributo.DT_RILASCIO_CARTA_DI_IDENTITA,
  codiciAttributo.DT_SCADENZA_CARTA_DI_IDENTITA,
  codiciAttributo.TX_COMUNE_DI_RILASCIO_CARTA_DI_IDENTITA,
  codiciAttributo.TX_NR_PASSAPORTO,
  codiciAttributo.DT_DATA_RILASCIO_PASSAPORTO,
  codiciAttributo.DT_DATA_SCADENZ_PASSAPORTO,
  codiciAttributo.TX_ENTE_RILASCIO_PASSAPORTO,
  codiciAttributo.TX_MOTIVO_PS,
  codiciAttributo.TX_NR_PS,
  codiciAttributo.TX_DATA_RILASCIO_PS,
  codiciAttributo.TX_DATA_SCADENZA_PS,
  codiciAttributo.TX_QUESTURA_RILASCIO_PS,
  codiciAttributo.TX_COMUNE_DOMICILIO,
  codiciAttributo.TX_INDIRIZZO_DOMICILIO,
  codiciAttributo.TX_COMUNE_RESIDENZA,
  codiciAttributo.TX_INDIRIZZO_RESIDENZA,
  codiciAttributo.TX_RECAPITO_TELEFONICO,
  codiciAttributo.TX_RECAPITO_TELEFONICO_2,
  codiciAttributo.TX_EMAIL,
  codiciAttributo.DT_DATA_RICHIESTA_RINNOVO_PS
];
